import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  User8yb1tqk4kykg as User,
  Companion_getInstance21u335vgn0mpe as Companion_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_emailn9rmxjmv5jjf as get_email,
  get_phoneNumberwyjkikct2tk8 as get_phoneNumber,
  get_addressm9hct5lany5j as get_address,
} from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertValidEmail3utsnuo6xdy4w as assertValidEmail,
  assertValidPhoneNumber13ya35cr3f72y as assertValidPhoneNumber,
} from '../../../utils/validation.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function UserForm$render$lambda(it) {
  return it.j88_1;
}
function UserForm$render$lambda_0(og, it) {
  return og.x88(VOID, VOID, VOID, VOID, it);
}
function UserForm$render$lambda_1(it) {
  return it.k88_1;
}
function UserForm$render$lambda_2(og, it) {
  return og.x88(VOID, VOID, VOID, VOID, VOID, it);
}
var UserFormClass;
function UserForm() {
  if (UserFormClass === VOID) {
    class $ {
      constructor(user, allowEditingEmail, widthLimit) {
        this.tj0_1 = user;
        this.uj0_1 = allowEditingEmail;
        this.vj0_1 = widthLimit;
        var tmp = this;
        tmp.wj0_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.let' call
          var it = $this$remember.baj(this.tj0_1).m88_1;
          return it == null || it.j8c_1.equals(MemberRole_Admin_getInstance());
        });
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'User Information';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.jba(view_0.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp = view_0.tb5_1;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_0 = '\xA0';
        } else {
          tmp_0 = content;
        }
        tmp.fbu(tmp_0);
        view.fbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = this.vj0_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        var tmp_1 = get_expanding(view_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_AppDimensions().pg2_1);
        view_3.jbb(get_centered(view_3), bodyBold(view_3, label));
        view_3.jbb(colored(view_3, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_3, '*'));
        view_2.fbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_2.hbb(FieldSemantic_getInstance());
        var tmp_3 = UserForm$render$lambda;
        var value = assertNotBlank(this.tj0_1.bak(tmp_3, UserForm$render$lambda_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.ebb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_0 = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_4.tb5_1.zb3_1.ib7_1.placeholder = value_0;
        view_4.xah(view_4.gcn_1, value);
        view_2.fbb(p_4, view_4);
        view_2.jbb(tmp_2, view_4);
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp_1, view_2);
        var tmp_4 = get_expanding(view_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_0 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.ebb(p_5, view_5);
        view_5.xbm(true);
        view_5.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xbm(false);
        view_6.zb8(get_AppDimensions().pg2_1);
        view_6.jbb(get_centered(view_6), bodyBold(view_6, label_0));
        view_6.jbb(colored(view_6, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_6, '*'));
        view_5.fbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view_5.hbb(FieldSemantic_getInstance());
        var tmp_6 = UserForm$render$lambda_1;
        var value_1 = assertNotBlank(this.tj0_1.bak(tmp_6, UserForm$render$lambda_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextInput())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.ebb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_2 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_7.tb5_1.zb3_1.ib7_1.placeholder = value_2;
        view_7.xah(view_7.gcn_1, value_1);
        view_5.fbb(p_7, view_7);
        view_5.jbb(tmp_5, view_7);
        view_1.fbb(p_5, view_5);
        view_1.jbb(tmp_4, view_5);
        view.fbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint_0 = this.vj0_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint_0)));
        var tmp0_elvis_lhs_8 = view.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
        view.ebb(p_8, view_8);
        if (this.uj0_1) {
          var tmp_7 = get_expanding(view_8);
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (RowOrCol())(view_8.pc());
          var tmp0_elvis_lhs_9 = view_8.cbb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
          view_8.ebb(p_9, view_9);
          view_9.xbm(true);
          view_9.zb8(get_AppDimensions().ng2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (RowOrCol())(view_9.pc());
          var tmp0_elvis_lhs_10 = view_9.cbb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
          view_9.ebb(p_10, view_10);
          view_10.xbm(false);
          view_10.zb8(get_AppDimensions().pg2_1);
          view_10.jbb(get_centered(view_10), bodyBold(view_10, 'Email'));
          view_10.jbb(colored(view_10, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_10, '*'));
          view_9.fbb(p_10, view_10);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_8 = view_9.hbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.tj0_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_9 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
          var tmp$ret$46 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$46);
          var tmp$ret$48 = get_email(it);
          var tmp$ret$49 = lensPath(this_0, tmp$ret$48);
          var value_3 = assertValidEmail(tmp$ret$49);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_11 = new (TextInput())(view_9.pc());
          var tmp0_elvis_lhs_11 = view_9.cbb_1;
          var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
          view_9.ebb(p_11, view_11);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view_11.tb5_1.zb3_1.ib7_1.placeholder = 'Email';
          view_11.xah(view_11.gcn_1, value_3);
          view_9.fbb(p_11, view_11);
          view_9.jbb(tmp_8, view_11);
          view_8.fbb(p_9, view_9);
          view_8.jbb(tmp_7, view_9);
        }
        var tmp_10 = get_expanding(view_8);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_1 = 'Phone Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_12 = view_8.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_8 : tmp0_elvis_lhs_12;
        view_8.ebb(p_12, view_12);
        view_12.xbm(true);
        view_12.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_12.pc());
        var tmp0_elvis_lhs_13 = view_12.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
        view_12.ebb(p_13, view_13);
        view_13.xbm(false);
        view_13.zb8(get_AppDimensions().pg2_1);
        view_13.jbb(get_centered(view_13), bodyBold(view_13, label_1));
        view_13.jbb(colored(view_13, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_13, '*'));
        view_12.fbb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_11 = view_12.hbb(FieldSemantic_getInstance());
        // Inline function 'com.crowpay.path' call
        Companion_getInstance();
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_12 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
        var tmp$ret$66 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
        var tmp$ret$68 = new (DataClassPathSelf())(tmp$ret$66);
        var value_4 = assertValidPhoneNumber(lensPath(this.tj0_1, get_phoneNumber(tmp$ret$68)));
        // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
        // Inline function 'kotlin.apply' call
        var this_1 = new (PhoneNumberInput())(view_12);
        this_1.tcl('Phone Number');
        view_12.xah(this_1.e2a(), value_4);
        view_12.jbb(tmp_11, this_1);
        view_8.fbb(p_12, view_12);
        view_8.jbb(tmp_10, view_12);
        view.fbb(p_8, view_8);
        var tmp_13 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(this.wj0_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_14 = view.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view : tmp0_elvis_lhs_14;
        view.ebb(p_14, view_14);
        view_14.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (Space())(view_14.pc());
        var tmp0_elvis_lhs_15 = view_14.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
        view_14.ebb(p_15, view_15);
        view_14.fbb(p_15, view_15);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = 'Billing Address';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (TextView())(view_14.pc());
        var tmp0_elvis_lhs_16 = view_14.cbb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
        view_14.ebb(p_16, view_16);
        view_16.jba(view_16.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_14 = view_16.tb5_1;
        var tmp_15;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_15 = '\xA0';
        } else {
          tmp_15 = content_0;
        }
        tmp_14.fbu(tmp_15);
        view_14.fbb(p_16, view_16);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.tj0_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_16 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
        var tmp$ret$90 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$90);
        var tmp$ret$92 = get_address(it_0);
        var tmp_17 = lensPath(this_2, tmp$ret$92);
        addressForm(view_14, tmp_17, VOID, VOID, ($this$addressForm) => !$this$addressForm.baj(this.wj0_1));
        view.fbb(p_14, view_14);
        view.jbb(tmp_13, view_14);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'UserForm', VOID, VOID, [Page()]);
    UserFormClass = $;
  }
  return UserFormClass;
}
//region block: exports
export {
  UserForm as UserForm7kih3xavfx72,
};
//endregion

//# sourceMappingURL=UserForm.mjs.map
